import { render, staticRenderFns } from "./TaskPreview.vue?vue&type=template&id=cc28e218&scoped=true&"
import script from "./TaskPreview.vue?vue&type=script&lang=js&"
export * from "./TaskPreview.vue?vue&type=script&lang=js&"
import style0 from "./TaskPreview.vue?vue&type=style&index=0&id=cc28e218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc28e218",
  null
  
)

export default component.exports